import * as React from "react";
import { CareerHeroSection } from "@/components/homepage2/CareerHeroSection";
import { HeroSocialProof } from "@/components/homepage2/HeroSocialProof";

import { SEO } from "@/components/seo/SEO";

// Lazy-load below-the-fold sections to improve FCP
const HeroVideoSection = React.lazy(() => import("@/components/homepage2/HeroVideoSection"));
const ResumeBuilderSection = React.lazy(() => import("@/components/homepage2/ResumeBuilderSection"));
const ResumeProcessSection = React.lazy(() => import("@/components/homepage2/ResumeProcessSection").then(m => ({ default: m.ResumeProcessSection })));
const ResumeEnhanceSection = React.lazy(() => import("@/components/homepage2/ResumeEnhanceSection").then(m => ({ default: m.ResumeEnhanceSection })));
const CoverLetterProcessSection = React.lazy(() => import("@/components/homepage2/CoverLetterProcessSection"));
const InterviewProcessSection = React.lazy(() => import("@/components/homepage2/InterviewProcessSection"));
const TestimonialsSection = React.lazy(() => import("@/components/landing/TestimonialsSection").then(m => ({ default: m.TestimonialsSection })));
const FAQSection = React.lazy(() => import("@/components/landing/FAQSection").then(m => ({ default: m.FAQSection })));
const Footer = React.lazy(() => import("@/components/Footer").then(m => ({ default: m.Footer })));
const Homepage2 = () => {
  return (
    <div className="bg-background min-h-screen">
      <SEO 
        title="Careerfy - AI-Powered Career Platform | Resume Builder & Interview Preparation India"
        description="Transform your career in India with Careerfy's AI-powered platform. Build professional resumes, practice interview skills, get career guidance, and land your dream job. Free tools for job seekers in India."
        path="/"
        image="https://www.careerfy.ai/lovable-uploads/135b3376-b684-4651-8f25-1bee28e6a6d7.png"
        type="website"
        structuredData={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Careerfy",
            url: "https://www.careerfy.ai/",
            logo: "https://www.careerfy.ai/logo.png",
            description: "AI-powered career acceleration platform for job seekers in India",
            sameAs: [
              "https://linkedin.com/company/careerfy",
              "https://twitter.com/careerfy"
            ],
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+91-XXX-XXX-XXXX",
              contactType: "Customer Service",
              areaServed: "IN",
              availableLanguage: ["English", "Hindi"]
            }
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Careerfy - AI Career Platform",
            url: "https://www.careerfy.ai/",
            description: "AI-powered career platform for Indian job seekers",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://www.careerfy.ai/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
            },
            publisher: {
              "@type": "Organization",
              name: "Careerfy"
            }
          },
          {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            name: "Careerfy Resume Builder",
            operatingSystem: "Web Browser",
            applicationCategory: "BusinessApplication",
            offers: {
              "@type": "Offer",
              price: "0",
              priceCurrency: "INR"
            },
            description: "AI-powered resume builder for Indian job market"
          },
          {
            "@context": "https://schema.org",
            "@type": "Service",
            name: "Interview Preparation",
            provider: {
              "@type": "Organization", 
              name: "Careerfy"
            },
            areaServed: "IN",
            description: "AI-powered mock interview practice for Indian job seekers"
          }
        ]}
      />
      <CareerHeroSection />
      
      <React.Suspense fallback={null}>
        <HeroVideoSection />
        <ResumeBuilderSection />
        
        {/* Transparent divider for spacing */}
        <div className="w-full hidden md:block md:h-48 bg-transparent" aria-hidden="true" />
        <ResumeProcessSection />
        {/* Transparent divider for spacing */}
        <div className="w-full hidden md:block md:h-48 bg-transparent" aria-hidden="true" />
        <ResumeEnhanceSection />
        {/* Transparent divider for spacing */}
        <div className="w-full hidden md:block md:h-48 bg-transparent" aria-hidden="true" />
        <CoverLetterProcessSection />
        <InterviewProcessSection />
        <TestimonialsSection />
        <FAQSection />
        <Footer />
      </React.Suspense>
    </div>
  );
};
export default Homepage2;